<template>
    <form>
    <b-modal :active.sync="isComponentModalActive"
             :full-screen.sync="isFullScreen"
             has-modal-card  >
 
        <div class="modal-card ">
            <header class="modal-card-head"  >

               <section class="modal-card-body  "  >
 
                   <b-tabs v-model="searchTab">

                       <b-tab-item label="Normal search"  icon="magnify">

                           <b-field grouped @keyup.native.enter="keyEnterPress" >

                               <b-field label="OPD No."
                                        :type="{ 'is-danger': hasErrorAllFieldBlank }"
                                        :message="{ 'please some input to search': hasErrorAllFieldBlank }"
                               >
                                   <b-input   v-model="OPDNo" placeholder="» » » » 63000001 « « « «"

                                   ></b-input>

                               </b-field>


                               <b-field label="Pet Name"
                                        :type="{ 'is-danger': hasErrorAllFieldBlank }"
                                        :message="{ 'please some input to search': hasErrorAllFieldBlank }"  >
                                   <b-input v-model="petName"  placeholder="» » » » » » แดง « « « « « «"
                                   ></b-input>
                               </b-field>


                               <b-field label="Owner Name"
                                        :type="{ 'is-danger': hasErrorAllFieldBlank }"
                                        :message="{ 'please some input to search': hasErrorAllFieldBlank }" >
                                   <b-input v-model="ownerName"  placeholder="» » » » » » สมชาย « « « « « « "
                                   ></b-input>
                               </b-field>


                               <b-field label="Owner Surname"
                                        :type="{ 'is-danger': hasErrorAllFieldBlank }"
                                        :message="{ 'please some input to search': hasErrorAllFieldBlank }" >
                                   <b-input v-model="ownersurname"  placeholder="» » » » » » นามสกุล « « « « « « "
                                   ></b-input>
                               </b-field>


                               <b-field label="Search">
                                   <b-button type="is-success" icon-left="magnify"  outlined @click="searchOPD" :disabled="isFullScreenSearching || !$v.OPDNo.maxLength"  ref="btnSearch"  ></b-button>
                               </b-field>


                               <b-field label="Clear All">
                                   <b-button type="is-success" icon-left="close"  outlined @click="initDat"   ref="btnClearAll"  ></b-button>
                               </b-field>




                                <b-field label="Lab No Automate" class="ml-5">
                                <template #label>
                                    Lab No Automate
                                    <b-switch size="is-small" v-model="isSwitchedSearchByLabNo"></b-switch>
                                </template>
                                <div class="field has-addons" v-if="isSwitchedSearchByLabNo">
                                    <div class="control">
                                    <b-input placeholder="Enter Lab No 66000112" type="search" v-model="labNoSearchByLab"></b-input>
                                    </div>
                                    <div class="control">
                                    <b-button  class="button is-primary" @click="searchByLabID">Search</b-button>
                                    </div>
                                </div>
                                </b-field>

<!--                               <b-field label="Search By Lab No." class="ml-5">-->
<!--                                         <template #label>-->
<!--                                            By LAB ID-->
<!--                                                <b-switch size="is-small" v-model="isSwitchedSearchByLabNo">-->
<!--                                                </b-switch>-->
<!--                                            </template>-->
<!--                                            <b-input placeholder="Search..." type="search" v-if="isSwitchedSearchByLabNo"></b-input>-->
<!--                                            <p class="control">-->
<!--                                                <b-button  size="is-small" class="button is-primary" v-if="isSwitchedSearchByLabNo">Search</b-button>-->
<!--                                            </p>-->

<!--                                </b-field>-->

                              

                           </b-field>

                           <b-message type="is-danger" v-if="!$v.OPDNo.maxLength">
                               Error max length for OPD no. are 8 char
                           </b-message>

                           <b-message type="is-danger" v-if="!$v.OPDNo.integer">
                               Error   OPD no. must be numberic (not character)
                           </b-message>

                       </b-tab-item>

                       <b-tab-item label="House number && Province search" icon="home-outline">
                           <b-field grouped @keyup.native.enter="keyEnterPress" >
                               <b-field label="House number"
                                        :type="{ 'is-danger': hasErrorHomeAddressFieldBlank }"
                                        :message="{ 'please some input to search': hasErrorHomeAddressFieldBlank }"
                               >
                                   <b-input   v-model="homeaddress" placeholder="» » » » 11/112 « « « «"

                                   ></b-input>
                               </b-field>
                               <b-field label="Province">
                                   <b-select placeholder="Select a name" v-model="provinceSelected">
                                       <option
                                               v-for="provinceDat in province"
                                               :value="provinceDat.id"
                                               :key="provinceDat.id"
                                                 >
                                           {{ provinceDat.name }}
                                       </option>
                                   </b-select>
                               </b-field>

                               <b-field label="Search">
                                   <b-button type="is-success" icon-left="magnify"  outlined @click="searchOPD" :disabled="isFullScreenSearching"  ref="btnSearch"  ></b-button>
                               </b-field>
                               <b-field label="Clear All">
                                   <b-button type="is-success" icon-left="close"  outlined @click="initDat"   ref="btnClearAll"  ></b-button>
                               </b-field>


                               



                           </b-field>

                       </b-tab-item>
                   </b-tabs>

               </section>

            </header>
            <section class="modal-card-body"  >
                <!-- Content ... -->
                <b-loading  :active.sync="isFullScreenSearching" ></b-loading>


<!--                <ul>-->
<!--                    <li   v-for="resultSearch in opdListResultSearch"  :key="resultSearch.idopd" > {{ resultSearch.name }}</li>-->
<!--                </ul>-->





<!--                <div class="row columns is-multiline">-->

<!--                    <div class="column is-4"   v-for="resultSearch in opdListResultSearch"  :key="resultSearch.idopd">-->
<!--                        <div class="card is-shady">-->
<!--                            <div class="card-content">-->
<!--                                <div class="content">-->

<!--                                    <span class="is-size-5 tag" style="color: indigo "> {{ resultSearch.name }}</span>-->
<!--                                    &nbsp;-->
<!--                                    <span  class="is-medium"> {{ resultSearch.idopd }}</span>-->
<!--                                    <hr>-->
<!--                                    <span  class="tag is-size-6"> {{ resultSearch.species}} -  {{ resultSearch.breed }}</span>-->
<!--                                    &nbsp;-->
<!--                                    <span>-->
<!--                                        <b-icon pack="fas"-->
<!--                                                :icon="resultSearch.sex === 'M' ? 'mars' : 'venus'">-->
<!--                                        </b-icon>-->
<!--                                    </span>-->
<!--                                    &nbsp;-->
<!--                                    <span  class="is-small"> {{ resultSearch.age}}</span>-->
<!--                                    <hr>-->
<!--                                    <b-icon-->
<!--                                            icon="account"-->
<!--                                            size="is-small">-->
<!--                                    </b-icon>&nbsp;<span >{{ resultSearch.owner_name }}</span>-->
<!--                                    <hr>-->
<!--                                    <b-icon-->
<!--                                            icon="home"-->
<!--                                            size="is-small">-->
<!--                                    </b-icon>&nbsp;<span >{{ resultSearch.address }}</span>-->
<!--                                    <hr>-->
<!--                                    <b-button type="is-success" icon-left="cursor-pointer"  outlined  @click="selectOPDNo(resultSearch.idopd)" >Enter...</b-button>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->










                <b-table
                        :data= "isEmpty ? []  : opdListResultSearch"
                        bordered
                        striped
                        hoverable
                        :loading="isTblLoading"
                        >


                        <b-table-column field="id" label="OPD No."  centered v-slot="props" >
                            <b-button type="is-info" @click="selectOPDNo(props.row.idopd)" v-if="mode == 0">{{ props.row.idopd }}</b-button>
                            <b-button type="is-info" @click="selectOPDNo_ForManualLabAutomate(props.row)" v-if="mode == 1">{{ props.row.idopd }}</b-button>
                        </b-table-column>

                        <b-table-column field="name" label="Pet Name" centered v-slot="props">
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column field="owner_name" label="Owner Name" centered v-slot="props">
                            {{ props.row.owner_name }}
                        </b-table-column>

                        <b-table-column field="age" label="Age" centered v-slot="props">
                            {{ props.row.age }}
                        </b-table-column>

                        <b-table-column label="Gender" v-slot="props">
                            <span>
                                <b-icon pack="fas"
                                        :icon="props.row.sex === 'M' ? 'mars' : 'venus'">
                                </b-icon>
                            </span>
                        </b-table-column>

                        <b-table-column field="species" label="Species" centered v-slot="props">
                            {{ props.row.species }}
                        </b-table-column>


                        <b-table-column field="breed" label="Breed" centered v-slot="props">
                            {{ props.row.breed }}
                        </b-table-column>

                        <b-table-column field="address" label="Address" centered v-slot="props">
                            {{ props.row.address }}
                        </b-table-column>

                        <b-table-column field="address" label="Mobile Phone" centered v-slot="props">
                            {{ props.row.phone_mobile }}
                        </b-table-column>


                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon
                                            icon="table-search"
                                            size="is-large">
                                    </b-icon>
                                </p>
                                <p>Nothing here.</p>
                            </div>
                        </section>
                    </template>


                    <template slot="footer"  >
                        <div class="box">
                            <div  class="level-left" >    </div>
                            <div  class="level-right" >    <b-button type="is-primary" outlined v-show="opdListResultSearch.length>0"   :disabled="isDisableMoreBtn" :loading="isMoreBtnLoading" @click="doFilter('m')"  >More..</b-button></div>
                        </div>
                    </template>


                </b-table>


            </section>
            <footer class="modal-card-foot">

                       <b-button type="is-danger"
                          icon-left="close"  @click="closeModal"   >
                       Close
                      </b-button>


            </footer>
        </div>

    </b-modal>
    </form>
</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios";
    import {mapActions, mapState} from "vuex";
    import { getBaseURLforBackEnd , getConfigAxios , firstSelectParam,checkAccessTokenWithFpValid  } from '@/utils.js'
    import { maxLength ,integer } from 'vuelidate/lib/validators'

    export default {
        name: "SearchOPD" ,
        props:{
            mode : Number, // 0 ---> normal , 1 ---> ForManualLabAutomate
        },
        methods:{
            ...mapActions({
                setupIDOPDTarget : 'opd_target/setupIDOPDTarget',
            }),
            selectOPDNo(opdno){
                this.$emit('closeWithChange',opdno)
                this.isComponentModalActive = false
            },


            selectOPDNo_ForManualLabAutomate(payload){
                this.$emit('closeWithChangeForManualLabAutomate',payload)
                this.isComponentModalActive = false
            },

             
            keyEnterPress(){
                // if(this.$refs.btnSearch.getAttribute('disabled'))
                // console.log(this.$v.OPDNo.maxLength)
                if(!this.isSwitchedSearchByLabNo){
                     if (this.$v.OPDNo.maxLength && this.$v.OPDNo.integer){
                    this.$refs.btnSearch.$el.click()
                   }
                }else{
                   this.searchByLabID() 
                }
               

            },
            initDat(){
                this.hasErrorAllFieldBlank = false,
                this.hasErrorHomeAddressFieldBlank = false
                this.OPDNo = ''
                this.opdListResultSearch = []
                this.ownerName = ''
                this.petName = ''
                this.ownersurname = ''
                this.homeaddress = ''
                this.provinceSelected = '10'
            },
            closeModal(){
                this.setupIDOPDTarget( this.tmpOPDSelected )
                this.isComponentModalActive = false

            },
            searchOPD() {

                const vm  = this
                checkAccessTokenWithFpValid(this.fingerPrint)
                    .catch(()=>{
                        vm.$router.push('/login')
                    })

                if(this.searchTab === 0){
                                    // check all blank
                                    if (this.OPDNo.length === 0 && this.petName.length === 0 && this.ownerName.length === 0 && this.ownersurname.length === 0  ) {
                                        this.hasErrorAllFieldBlank = true
                                        return
                                        // check OPD No. only
                                    } else if (this.OPDNo.length < 3 && this.petName.length === 0 && this.ownerName.length === 0 && this.ownersurname.length === 0 ) {
                                        this.$buefy.dialog.alert({
                                            title: 'Error',
                                            message: 'Should more than 3 character for search OPD No. only!',
                                            type: 'is-danger',
                                            hasIcon: true,
                                            icon: 'times-circle',
                                            iconPack: 'fa',
                                            ariaRole: 'alertdialog',
                                            ariaModal: true
                                        })
                                        return
                                        // Pet Name Only
                                    } else if (this.OPDNo.length === 0 && this.petName.length < 2 && this.ownerName.length === 0 && this.ownersurname.length === 0  ) {
                                        this.$buefy.dialog.alert({
                                            title: 'Error',
                                            message: 'Should more than 2 character for search pet name only!',
                                            type: 'is-danger',
                                            hasIcon: true,
                                            icon: 'times-circle',
                                            iconPack: 'fa',
                                            ariaRole: 'alertdialog',
                                            ariaModal: true
                                        })
                                        return
                                        //  ownerName Only
                                    } else if (this.OPDNo.length === 0 && this.petName.length === 0 && this.ownerName.length < 3 && this.ownersurname.length === 0  ) {
                                        this.$buefy.dialog.alert({
                                            title: 'Error',
                                            message: 'Should more than 3 character for search owner name only!',
                                            type: 'is-danger',
                                            hasIcon: true,
                                            icon: 'times-circle',
                                            iconPack: 'fa',
                                            ariaRole: 'alertdialog',
                                            ariaModal: true
                                        })
                                        return
                                        //  ownerSurName Only
                                    } else if(this.OPDNo.length===0 && this.petName.length ===0  && this.ownerName.length === 0 && this.ownersurname.length <3   ){
                                        this.$buefy.dialog.alert({
                                            title: 'Error',
                                            message: 'Should more than 3 character for search owner surname only!',
                                            type: 'is-danger',
                                            hasIcon: true,
                                            icon: 'times-circle',
                                            iconPack: 'fa',
                                            ariaRole: 'alertdialog',
                                            ariaModal: true
                                        })
                                        return
                                    } else{
                                        this.doFilter('f')
                                    }
                }
                else{
                                    if (this.homeaddress.length === 0) {
                                        this.hasErrorHomeAddressFieldBlank = true
                                        return
                                    } else{
                                        this.doFilter('f')
                                    }
                }
            },
            doFilter(firstFreshOrMore){
                // fresh === 'f' , more === 'm'
                if(!this.user_id){
                    this.$router.push('/login')
                        .catch(()=>{});
                    return
                }

                this.hasErrorAllFieldBlank = false
                this.isFullScreenSearching = true
                this.isShowSearchInfo = false
                if(firstFreshOrMore === 'f') {
                    this.opdListResultSearch = []
                    this.skipQrySelect  = 0
                    this.isDisableMoreBtn = false
                    this.dataOwnerMore = []
                }
                this.isTblLoading = true

                //****************************
                if(firstFreshOrMore === 'm'){
                    this.skipQrySelect =   this.skipQrySelect +firstSelectParam()
                    this.isMoreBtnLoading = true
                }else{
                    this.isMoreBtnLoading = false
                }

                const datToFilter =
                                    {
                                        "type": this.searchTab === 0 ? "1" : "2",
                                        "first":  firstSelectParam(),
                                        "skip": this.skipQrySelect ,
                                        "dat_type1":{
                                                        "idopd": this.OPDNo,
                                                        "owner": this.ownerName ,
                                                        "ownersurname": this.ownersurname,
                                                        "opdname": this.petName,
                                                        "idown" : ""
                                                    } ,
                                        "dat_type2" :{
                                                        "homeaddress": this.homeaddress,
                                                        "idprovince":  this.provinceSelected
                                                    },
                                        "user": this.user_id,
                                        "ip": this.clientIP

                                    }


                var vm = this
                // attach access_token it  access_token
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/search_opd_v2`,datToFilter,getConfigAxios())

                    .then(function (response) {
                        if(firstFreshOrMore === 'f') {
                            vm.opdListResultSearch = response.data
                        } else{
                            vm.opdListResultSearch =vm.opdListResultSearch.concat( response.data )
                        }
                        vm.isFullScreenSearching = false
                        vm.isTblLoading = false
                        if(firstFreshOrMore === 'm'){
                            vm.isMoreBtnLoading = false
                            if (response.data.length === 0){
                                vm.isDisableMoreBtn = true
                                vm.$buefy.dialog.alert({
                                    title: 'Infomation',
                                    message: 'Nothing to load any more',
                                    type: 'is-info',
                                    hasIcon: true,
                                    icon: 'database-export',
                                    iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true
                                })
                            }
                        }
                    })
                    .catch( function(err) {


                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')
                        }

                        else if (err.response && err.response.status === 422) {
                            vm.isFullScreenLoading = false
                            vm.$buefy.dialog.alert({
                                title: 'Error',
                                message: `Token expired , please login again`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true,
                                onConfirm: () =>   vm.$router.go()
                            })


                        }

                        else{
                            vm.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err.response.data.msg}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                        }
                    })




            },

            searchByLabID(){
                this.isFullScreenSearching = true
                const datTo = {
                    "ln" : this.labNoSearchByLab
                }
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/search_opd_bylabid`,datTo,getConfigAxios())
                      .then((res)=>{
                         this.opdListResultSearch = res.data
                         this.isFullScreenSearching = false
                         if(res.data.length==0){
                                this.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `Not Found for Lab ID : ${this.labNoSearchByLab}`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'alert-circle',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true
                                })
                         }
                      })
                      .catch(()=>{
                        this.isFullScreenSearching = false
                      })
            }
        },
        validations:{
            OPDNo :{
                maxLength :   maxLength(8),
                integer
            }
        },
        data(){
            return{
                isFullScreen : true,
                isComponentModalActive : false,
                OPDNo : "",
                petName : "",
                ownerName : "",
                ownersurname : "",
                homeaddress : "",
                hasErrorAllFieldBlank : false,
                hasErrorHomeAddressFieldBlank : false,
                skipQrySearch : 0,
                opdListResultSearch :[],
                isFullScreenSearching : false,
                isEmpty: false,
                isTblLoading : false,
                skipQrySelect : 0,
                isMoreBtnLoading : false ,
                isDisableMoreBtn : false ,
                searchTab : 0,
                provinceSelected : '10', // Bangkok,
                tmpOPDSelected : null,

                isSwitchedSearchByLabNo : false,
                labNoSearchByLab : "",
            }
        },
        computed:{
            ...mapState({
                OPDSelected : state => state.opd_target.opd_selected,
                province : state => state.master_data.province ,
                fingerPrint : state => state.master_data.fingerPrint,
                user_id : state => state.master_data.user_id,
                clientIP : state => state.master_data.clientIP,
                access_token : state => state.master_data.access_token,
            }) ,
            OPDNoPetNameOwnerNameChange() {
                const {OPDNo, petName ,ownerName} = this
                return {OPDNo, petName ,ownerName}
            } ,
            isComponentModalActiveChange(){
                const {isComponentModalActive} = this
                return {isComponentModalActive}
            },

        },
        watch:{
            OPDNoPetNameOwnerNameChange:{
                handler: function (val) {
                   if(val.OPDNo.length>0 || val.petName.length>0 || val.ownerName.length>0 ) {
                       this.hasErrorAllFieldBlank = false
                   }
                   // }else{
                   //     this.hasErrorAllFieldBlank = true
                   // }
                },
                deep : true
            },
            isComponentModalActiveChange :{
                handler: function (newVal, oldVal) {

                    if(newVal.isComponentModalActive && !oldVal.isComponentModalActive){
                        this.isFullScreenSearching = true
                        this.tmpOPDSelected = this.OPDSelected
                        this.setupIDOPDTarget(null)

                        this.hasErrorAllFieldBlank = false
                        this.isEmpty = false

                        this.labNoSearchByLab = ""
                        this.isSwitchedSearchByLabNo = false

                        this.isFullScreenSearching = false
                    }
                },
                deep : true
            }
        }
    }
</script>

<style scoped>

</style>